export const CONTACT_INVITE_STATUSES = {
    completed: 'Completed',
    expired: 'Expired',
    failed: 'Failed',
    sent: 'Sent'
};
